import { createContext } from 'react'

export const PageContext = createContext<
  Required<Queries.ContentfulDeprecatedPageQuery>['page']
>({} as Required<Queries.ContentfulDeprecatedPageQuery>['page'])
